import { FC, useState } from "react"
import { WearableSensorStatus } from "@/api/SensorsService"
import Checkbox from "@/components/shared/Checkbox"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import { AlertSystemConditionType } from "@/types/alertConfigurations"

export interface Filter {
   type: null | AlertSystemConditionType | WearableSensorStatus | string
   id: string
   iconName: IconProps["name"] | null
   label: string
   checked: boolean
}

interface FilterGroupProps {
   groupTitle: string
   filters: Filter[]
   folded?: boolean
   onChange: (filter: Filter, checked: boolean) => void
}

const FilterGroup: FC<FilterGroupProps> = ({
   groupTitle,
   filters,
   folded = false,
   onChange,
}) => {
   const [foldedState, setFoldedState] = useState(folded)
   return (
      <div className="wearables-overview__filter-group">
         <div className="wearables-overview__filter-title">
            <span>{groupTitle}</span>
            <Icon
               name="arrowDown"
               size="8"
               color={IconColor.COOL_GRAY}
               onClick={() => {
                  setFoldedState(!foldedState)
               }}
            />
         </div>
         {!foldedState &&
            filters.map((filter, index) => (
               <Checkbox
                  key={`filter-${index}`}
                  id={filter.id}
                  label={filter.label}
                  checked={filter.checked}
                  {...(filter.iconName && { iconName: filter.iconName })}
                  iconColor={IconColor.HONOLULU_BLUE}
                  onChange={(checked: boolean) => {
                     filter.checked = checked
                     onChange(filter, checked)
                  }}
               />
            ))}
      </div>
   )
}

export default FilterGroup
